<template>
  <modal-form :submit="submit" v-model="show" size="md">
    <template v-slot:title> Solicitação Relatório </template>
    <template v-slot:body>
      <v-row>
        <v-col class="pb-0" cols="12" md="6">
          <input-select
            v-model="tipoArquivo"
            :options="tipoArquivoRelatorio"
            label="Tipo Arquivo"
            required
            single
          />
        </v-col>
        <v-col class="pb-0" cols="12" md="6">
          <v-switch
            class="mt-0 mx-3"
            inset
            v-model="enviarEmail"
            label="Permitir notificação via email"
          />
        </v-col>
      </v-row>
    </template>
  </modal-form>
</template>

<script>
export default {
  data () {
    return {
      show: false,
      tipoArquivo: null,
      enviarEmail: false,
    };
  },
  props: {
    tipoArquivoRelatorio: Array
  },
  methods: {
    openModal (sender) {
      this.show = true;
    },
    submit () {
      this.show = false
      const model = {
        enviarEmail: this.enviarEmail,
        tipoArquivo: this.tipoArquivo
      }
      this.$emit('solicitarRelatorio', model);
    }
  }
};
</script>
